import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { WHITELABELINFO } from 'lib/context';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

export interface LogoutUserParams {
  redirect?: string;
}

const logoutUser = async ({ redirect = '' }: LogoutUserParams) => {
  const response = await EXPRESS_API.post(
    '/auth/logout',
    {
      redirect,
    },
    { withCredentials: true }
  );
  return response.data;
};

export const useLogoutUser = (isSubUser = false) => {
  const { t } = useTranslation();
  return useMutation(logoutUser, {
    onSuccess: data => {
      if (!!isSubUser) {
        if (!!window.opener) {
          window.close();
          return;
        }
        window.location.reload();
        return;
      }
      successToast({
        title: t(`User has been logged out successfully.`),
      });

      localStorage.setItem(WHITELABELINFO, '');
      if (data && data.redirectUrl) {
        window.location.href = data.redirectUrl;
      }
    },
  });
};
